import {
  VizPortalDQWDataCatalogProvider,
  VizPortalDQWDataCatalogProviderProps,
  WarningStatusChip,
  WarningStatusProps,
} from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';
import { Query } from 'react-apollo';

import {
  WorkbookLineageUpstreamDataQualityWarningsQuery,
  WorkbookLineageUpstreamDataQualityWarningsQueryVariables,
} from '../../../gen-src/queries/WorkbookLineageUpstreamDataQualityWarningsQuery';
import { WorkbookLineageUpstreamDataQualityWarningsQueryGql } from '../../queries/WorkbookLineageUpstreamDataQualityWarningsQueryGql';
import { ErrorListProvider } from '../error/components/ErrorListProvider';
import { renderQueryResult } from '../renderQueryResult';
import { emptyWarnings } from './DataQualityWarningCycleTemporaryFix';

interface LineageWarningWorkbookProps {
  readonly vizportalUrlId: string;
}

export type EmbeddableWorkbookDataQualityWarningProps = VizPortalDQWDataCatalogProviderProps & LineageWarningWorkbookProps;

export function EmbeddableWorkbookDataQualityWarning(props: EmbeddableWorkbookDataQualityWarningProps): JSX.Element {
  const { featureFlags: { publishedConnectionsLineageEnabled }, siteUrls: urls } = props;

  const renderData = React.useMemo(() => renderWarnings(urls),
    [urls]);

  return (
    <VizPortalDQWDataCatalogProvider {...props}>
      <ErrorListProvider>
        <Query<WarningQuery, WarningVariables>
          query={WorkbookLineageUpstreamDataQualityWarningsQueryGql}
          variables={{ workbookVizportalUrlId: props.vizportalUrlId, first: 10, offset: 0, publishedConnectionsLineageEnabled }}
        >
          {result => renderQueryResult(result, { renderData })}
        </Query>
      </ErrorListProvider>
    </VizPortalDQWDataCatalogProvider>
  );

}

type WarningQuery = WorkbookLineageUpstreamDataQualityWarningsQuery;
type WarningVariables = WorkbookLineageUpstreamDataQualityWarningsQueryVariables;

function renderWarnings(urls: SiteUrls): (data: WarningQuery) => JSX.Element | null {
  return (data: WarningQuery): JSX.Element | null => {
    const workbook = data.workbooks && data.workbooks[0] ? data.workbooks[0] : null;
    if (!workbook) {
      return null;
    }

    const props: WarningStatusProps = {
      subjectArea: 'Workbook',
      kind: 'graph',
      anchoredAsset: null,
      anchoredWarnings: [],
      iconOnly: false,
      urls,
      upstreamWarnings: workbook.upstreamDataQualityWarningsConnection?.nodes ?? emptyWarnings
    }

    return <WarningStatusChip {...props} />
  }
}
